import React from "react";
import { i18n } from "../../translate/i18n";
import StandardModal from "../ui/StandardModal";

const ShowTicketOpen = ({ isOpen, handleClose, user, queue }) => {
  return (
    <StandardModal
      open={isOpen}
      onClose={handleClose}
      title={i18n.t("showTicketOpenModal.title.header")}
      maxWidth="xs"
      cancelText="Fechar"
      showFooter={true}
      onConfirm={undefined}
    >
      {user !== undefined && queue !== undefined && (
        <div>
          {i18n.t("showTicketOpenModal.form.message")} <br />
          {`${i18n.t("showTicketOpenModal.form.user")}: ${user}`}
          <br />
          {`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}
          <br />
        </div>
      )}
      {!user && (
        <div>
          {i18n.t("showTicketOpenModal.form.messageWait")} <br />
          {queue && `${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}
          <br />
        </div>
      )}
    </StandardModal>
  );
};

export default ShowTicketOpen;
